import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
            <div className="w-16 h-16 mx-auto mb-5 rounded-2xl bg-background-50/20 backdrop-blur-sm flex items-center justify-center">
              <i className="ri-smartphone-line text-3xl text-background-50"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-extrabold text-background-50 font-heading mb-3">
              {appInfo.title}
            </h2>
            <p className="text-sm md:text-base text-background-50/80 mb-8">
              {appInfo.subtitle}
            </p>

            <div className="grid grid-cols-2 gap-3 max-w-md mx-auto mb-8">
              {appInfo.features.map((feat, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 bg-background-50/15 backdrop-blur-sm rounded-lg px-3 py-2.5"
                >
                  <i className="ri-check-line text-background-50 flex-shrink-0 text-sm"></i>
                  <span className="text-xs text-background-50 text-left leading-tight">{feat}</span>
                </div>
              ))}
            </div>

            <a
              href="#hero"
              onClick={(e) => { e.preventDefault(); }}
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              立即访问网页版
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}